var map = {};
var queryString = '';
var nameValue = '';

function getQueryString(key) {
    var requestUrl = window.location.search.substring(1);
    queryString = requestUrl.split("&");
    for (i = 0; i < queryString.length; i++) {
        nameValue = queryString[i].split("=");
        if (nameValue[0] == key) {
            return nameValue[1];
        }
    }
}

$(document)
    .bind('addShape', function (evt, shape) {
        var url = '/MapSearch/Add';
        var data = { sessionId: getQueryString("bas_session") };
        var i;

        url += 'Shape';
        data.latitudes = [];
        data.longitudes = [];
        if (shape.data.name.length > 256) {
            shape.data.name = shape.data.name.substring(0, 256);
        }
        data.name = shape.data.name;
        data.type = shape.data.type;
        
        i = shape.data.points.length;
        while (i--) {
            data.latitudes.push(shape.data.points[i].lat);
            data.longitudes.push(shape.data.points[i].lon);
        }
        data.bottom = shape.data.bounds.bottom;
        data.left = shape.data.bounds.left;
        data.top = shape.data.bounds.top;
        data.right = shape.data.bounds.right;


        data.exclude = shape.data.exclude;
        data.remove = shape.data.geometryChanged === undefined ? false : shape.data.geometryChanged;

        $.ajax({
            type: 'POST',
            url: url,
            data: JSON.stringify(data),
            contentType: 'application/json, charset=utf-8',
            dataType: 'json',
            success: function (counts) {
                $('div.adc-popup-note').text($('div.adc-popup-note').text().replace('total ', ''));
                shape.setShapeNote(counts + ' leads');
                //remove the word results from note. so that it displays just the number of results on shape
                shape.setNote('This shape contains ' + counts + ' total leads.');
                updateFrontend();
            },
            error: function (msg) {
                alert('Error: ' + msg.responseText);
            }
        });
    });

$(document)
    .bind('addBoundary', function (evt, shape) {
        var url = '/MapSearch/AddBoundary';
        var data = { sessionId: getQueryString("bas_session") };
        
        if (shape.data.name.length > 256) {
            shape.data.name = shape.data.name.substring(0, 256);
        }
        data.name = shape.data.name;
        
        data.value = shape.data.value;
        if (shape.data.layer !== '') {
            switch (shape.data.layer) {
                case "Metro Areas":
                    data.layer = 'CBSACODE';
                    break;
                case "Area Codes":
                    data.layer = 'AREACODE';
                    break;
                case "Counties":
                    data.layer = 'COUNTYCODEBYSTATECODE';
                    break;
                case "ZIP Codes":
                    data.layer = 'ZIPCODE';
                    break;
                case "Cities":
                    data.layer = 'citybystate';
                    break;
                case "Carrier Routes":
                    data.layer = 'CARRIERROUTEBYZIPCODE';
                    break;
                case "Neighborhoods":
                    data.layer = 'NID';
                    break;
                default:
                    data.layer = 'STATE';
                    break;
            }
        }
        data.bottom = shape.data.bounds.bottom;
        data.left = shape.data.bounds.left;
        data.top = shape.data.bounds.top;
        data.right = shape.data.bounds.right;

        data.exclude = shape.data.exclude;
        data.remove = shape.data.geometryChanged === undefined ? false : shape.data.geometryChanged;

        $.ajax({
            type: 'POST',
            url: url,
            data: JSON.stringify(data),
            contentType: 'application/json, charset=utf-8',
            dataType: 'json',
            success: function (counts) {
                $('div.adc-popup-note').text($('div.adc-popup-note').text().replace('total ', ''));
                shape.setShapeNote(counts + ' leads');
                //remove the word results from note. so that it displays just the number of results on shape
                shape.setNote('This shape contains ' + counts + ' total leads.');
                updateFrontend();
            },
            error: function (msg) {
                alert('Error: ' + msg.responseText);
            }
        });
    });

$(document)
    .bind('addRoute', function (evt, shape) {
        var url = '/MapSearch/AddRoute';
        var data = { sessionId: getQueryString("bas_session") };
        var i;

        data.latitudes = [];
        data.longitudes = [];
       
        if (shape.data.name.length > 256) {
            shape.data.name = shape.data.name.substring(0, 256);
        }
        data.name = shape.data.name;

        data.type = shape.data.type;
        i = shape.data.points.length;
        while (i--) {
            data.latitudes.push(shape.data.points[i].lat);
            data.longitudes.push(shape.data.points[i].lon);
        }
        data.bottom = shape.data.bounds.bottom;
        data.left = shape.data.bounds.left;
        data.top = shape.data.bounds.top;
        data.right = shape.data.bounds.right;

        data.exclude = shape.data.exclude;
        data.remove = shape.data.geometryChanged === undefined ? false : shape.data.geometryChanged;

        $.ajax({
            type: 'POST',
            url: url,
            data: JSON.stringify(data),
            contentType: 'application/json, charset=utf-8',
            dataType: 'json',
            success: function (counts) {
                $('div.adc-popup-note').text($('div.adc-popup-note').text().replace('total ', ''));
                shape.setShapeNote(counts + ' leads');
                //remove the word results from note. so that it displays just the number of results on shape
                shape.setNote('This shape contains ' + counts + ' total leads.');
                updateFrontend();
            },
            error: function (msg) {
                alert('Error: ' + msg.responseText);
            }
        });
    });

$(document)
    .bind('addRadius', function (evt, shape) {
        var url = '/MapSearch/AddRadius';
        var data = { sessionId: getQueryString("bas_session") };

        data.latitude = shape.data.centerPt.lat;
        data.longitude = shape.data.centerPt.lon;
        data.radius = shape.data.distance;
       
        if (shape.data.name.length > 256) {
            shape.data.name = shape.data.name.substring(0, 256);
        }
        data.name = shape.data.name;

        data.exclude = shape.data.exclude;
        data.remove = shape.data.geometryChanged === undefined ? false : shape.data.geometryChanged;

        $.ajax({
            type: 'POST',
            url: url,
            data: JSON.stringify(data),
            contentType: 'application/json, charset=utf-8',
            dataType: 'json',
            success: function (counts) {
                $('div.adc-popup-note').text($('div.adc-popup-note').text().replace('total ', ''));
                shape.setShapeNote(counts + ' leads');
                //remove the word results from note. so that it displays just the number of results on shape
                shape.setNote('This shape contains ' + counts + ' total leads.');
                updateFrontend();
            },
            error: function (msg) {
                alert('Error: ' + msg.responseText);
            }
        });
    });

$(document).bind('updateCounts', function (evt, type) {
    //log('updateCounts');
    var arr = map.dump();

    //these are used to display shape info on map portlet.
    var raddii = [];
    var routes = [];
    var shapes = [];
    var boundaries = [];
    for (var x = 0; x < arr.length; x++) {
        switch (arr[x].data.type) {
            case 'boundary':
                //boundaries = boundaries + arr[x].data.value + ',';
//                boundaries.push(arr[x].data.value);
                boundaries.push(arr[x].data.name);
                break;
            case 'radius':
                //raddii = raddii + arr[x].data.name + ',';
                raddii.push(arr[x].data.name);
                break;
            case 'route':
                //routes = routes + arr[x].data.name + ',';
                routes.push(arr[x].data.name);
                break;
            case 'shape':
                //shapes = shapes + arr[x].data.name+ ',';
                shapes.push(arr[x].data.name);
                break;
        }
    }
    //if (shapes.length > 0)
    //    shapes = shapes.substring(0, shapes.length - 1);

    $.ajax({
        type: 'POST',
        //contentType: 'application/json',
        dataType: 'json',
        url: '/MapSearch/DeleteMapShape',
        data: {
            shapes: shapes,
            raddii: raddii,
            driveRoutes: routes,
            boundaries: boundaries
        },
        traditional: true,
        success: function () {

        },
        error: function (xhr, error, thrown) {
            alert('update counts ' + error);
        }
    });
})



.bind('clearAllSelections', function (evt, data) {
    $.ajax({
        type: 'DELETE',
        url: '/MapSearch/ClearAll',
        data: { sessionId: getQueryString("bas_session") },
        success: function (counts) {
        }
    });
    $(document).removeData('selectedShapes');
});
/*
 * Initialize global InfoMap object
 * to be called when InfoMap is ready to be consumed
 */
function loadDataToMap(data) {
    map.clean(true).load(data, function (results) {
        for (var x = 0; x < results.length; x++) {
            var noteParts = results[x].data.note.split(" ");

            results[x].setShapeNote(noteParts[3] + ' leads');
        }
        map.zoomToData();
    });
}

function updateFrontend() {
    var arr = map.dump();
    var jsonObj = {};
    jsonObj.shapes = [];
    jsonObj.routes = [];
    jsonObj.boundaries = [];
    jsonObj.radii = [];

    for (var i = 0; i < arr.length; i++) {

        if (arr[i].data.type === "shape")
            jsonObj.shapes.push({
                name: arr[i].data.name, points: arr[i].data.points, type: arr[i].data.type, exclude: arr[i].data.exclude,
                note: arr[i].data.note
            });
        if (arr[i].data.type === "route")
            jsonObj.routes.push({
                name: arr[i].data.name, points: arr[i].data.points, type: arr[i].data.type, exclude: arr[i].data.exclude,
                note: arr[i].data.note
            });
        if (arr[i].data.type === "boundary")
            jsonObj.boundaries.push({
                name: arr[i].data.name, bottom: arr[i].data.bounds.bottom, left: arr[i].data.bounds.left,
                right: arr[i].data.bounds.right, top: arr[i].data.bounds.top,
                type: arr[i].data.type, exclude: arr[i].data.exclude,
                note: arr[i].data.note, layer: arr[i].data.layer, value: arr[i].data.value
            });
        if (arr[i].data.type === "radius")
            jsonObj.radii.push({
                name: arr[i].data.name, centerPt: arr[i].data.centerPt, type: arr[i].data.type, exclude: arr[i].data.exclude,
                note: arr[i].data.note, distance: arr[i].data.distance
            });
    }

    $.ajax({
        type: 'POST',
        contentType: 'application/json, charset=utf-8',
        dataType: 'json',
        url: '/MapSearch/UpdateFrontend',
        data: JSON.stringify(jsonObj),
        success: function () {
            //alert('worked');
        },
        error: function (xhr, error, thrown) {
            //alert('didn\'t work' + error);
        }
    });
}

function isPointWithinBounds(longitude, latitude, boundsBottom, boundsTop, boundsLeft, boundsRight) {
    var longitudeContained = false;
    var latitudeContained = false;

    // Check if the bbox contains the prime meridian (longitude 0.0).
    if (boundsLeft < boundsRight) {
        if (boundsLeft < longitude && longitude < boundsRight) {
            longitudeContained = true;
        }
    }
    else {
        // Contains prime meridian.
        if ((0 < longitude && longitude < boundsRight) ||
            (boundsRight < longitude && longitude < 0)) {
            longitudeContained = true;
        }
    }

    if (boundsLeft < boundsRight) {
        if (boundsBottom < latitude && latitude < boundsTop) {
            latitudeContained = true;
        }
    }
    else {
        // The poles. Don't care.
    }

    return (longitudeContained && latitudeContained);
}

function doBoundingBoxesIntersect(startingLeft, startingRight, startingTop, startingBottom, left, right, top, bottom) {
    //points to check
    //l,t
    //r,t
    //r,b
    //l,b

    var lt = isPointWithinBounds(left, top, startingBottom, startingTop, startingLeft, startingRight);
    var rt = isPointWithinBounds(right, top, startingBottom, startingTop, startingLeft, startingRight);
    var rb = isPointWithinBounds(right, bottom, startingBottom, startingTop, startingLeft, startingRight);
    var lb = isPointWithinBounds(left, bottom, startingBottom, startingTop, startingLeft, startingRight);

    return (lt || rt || rb || lb);
}

function isCurrentBoundsWithinStartingBounds(left, right, top, bottom) {
    //points to check
    //l,t
    //r,t
    //r,b
    //l,b

    //hawaii
    var HawaiiLeft = -162;
    var HawaiiRight = -155;
    var HawaiiTop = 23;
    var HawaiiBottom = 18.5;

    //Need to check if any of the points are within the original bounding box
    //If they any of them are return true
    var inHawaiiBounds = doBoundingBoxesIntersect(HawaiiLeft, HawaiiRight, HawaiiTop, HawaiiBottom, left, right, top, bottom);

    //continental US
    var continentalUSLeft = -138.4;
    var continentalUSRight = -51.8;
    var continentalUSTop = 50;
    var continentalUSBottom = 24.2;

    //Need to check if any of the points are within the original bounding box
    //If they any of them are return true
    var inContinentalUSBounds = doBoundingBoxesIntersect(continentalUSLeft, continentalUSRight, continentalUSTop, continentalUSBottom, left, right, top, bottom);

    //canada
    var canadaLeft = -138.4;
    var canadaRight = -51.8;
    var canadaTop = 71.6;
    var canadaBottom = 49.9;

    //Need to check if any of the points are within the original bounding box
    //If they any of them are return true
    var inCanadaBounds = doBoundingBoxesIntersect(canadaLeft, canadaRight, canadaTop, canadaBottom, left, right, top, bottom);
    
    //alaska1
    var alaska1Left = -169.4;
    var alaska1Right = -138.4;
    var alaska1Top = 71.6;
    var alaska1Bottom = 50.9;

    //Need to check if any of the points are within the original bounding box
    //If they any of them are return true
    var inAlaska1Bounds = doBoundingBoxesIntersect(alaska1Left, alaska1Right, alaska1Top, alaska1Bottom, left, right, top, bottom);
    
    //alaska2
    var alaska2Left = -171.7;
    var alaska2Right = -169.4;
    var alaska2Top = 54.4;
    var alaska2Bottom = 49.9;

    //Need to check if any of the points are within the original bounding box
    //If they any of them are return true
    var inAlaska2Bounds = doBoundingBoxesIntersect(alaska2Left, alaska2Right, alaska2Top, alaska2Bottom, left, right, top, bottom);
    
    //alaska3
    var alaska3Left = -171.7;
    var alaska3Right = -169.4;
    var alaska3Top = 64;
    var alaska3Bottom = 54.4;

    //Need to check if any of the points are within the original bounding box
    //If they any of them are return true
    var inAlaska3Bounds = doBoundingBoxesIntersect(alaska3Left, alaska3Right, alaska3Top, alaska3Bottom, left, right, top, bottom);

    return (inHawaiiBounds || inContinentalUSBounds || inCanadaBounds || inAlaska1Bounds || inAlaska2Bounds || inAlaska3Bounds);
}

$.fn.initMapBasedSearch = function (data) {
    var id = $(this).attr('id');
    var helpText = $('#mapSearchHelp').html();
    $('#mapSearchHelp').remove();
    $('#shapesList').remove();
    var $parent = $(this).closest('div.originModal');
    $parent.css({ padding: '0 0 0 0' });
    $(this).css({
        width: '100%',
        height: '550px'
    });

    InfoMapLoad(function () {
        if (!$.isFunction(map.clean)) { //if an instance of map doesn't exist then create one otherwise use existing
            //log('creating new map instance');

            var options = {
                mode: 'geoselect',
                toolbar: true,
                toolbarTools: ['zoomto', 'boundaryselect', 'drawshape', 'defineradius', 'driveroute', 'showall', 'clearall', 'print', 'help'],
                toolbarMode: "mini",
                sidebar: true,
                sidebarContent: '<p><strong>To begin</strong> zoom to an area by entering a city, state, ZIP code, etc. or with the zoom tools.</p><p><strong>To select a geographic area</strong> use the selection tools above the map.</p><p>Once you have made selections, your results will appear in this area.</p>',
                sidebarCollapsed: false,
                helpContent: helpText,//'help content goes here',
                overview: true,
                overviewCollapsed: false,
                baseMaps: ['street', 'satellite', 'hybrid', 'terrain'],
                activeBaseMap: 'street',
                preventAutoPopups: false,
                popupWidth: 230,
                popupHeight: 200//,
                //debug: true
            };
            map = new InfoMap(id, options);
            map.setCenter(-98, 39, 4); //set USA as the center point on the map.

            map.on({
                radiusadded: function (result) {
                    $(document).trigger('addRadius', [result]);
                },
                radiusmodified: function (result) {
                    $(document).trigger('addRadius', [result]);
                },
                radiusremoved: function (result) {
                    if (!result.isClearAll)
                        $(document).trigger('updateCounts');
                },

                shapeadded: function (result) {
                    $(document).trigger('addShape', [result]);
                },
                shapemodified: function (result) {
                    $(document).trigger('addShape', [result]);
                },
                shaperemoved: function (result) {
                    if (!result.isClearAll)
                        $(document).trigger('updateCounts');
                },

                routeadded: function (result) {
                    $(document).trigger('addRoute', [result]);
                },
                routemodified: function (result) {
                    $(document).trigger('addRoute', [result]);
                },
                routeremoved: function (result) {
                    if (!result.isClearAll)
                        $(document).trigger('updateCounts');
                },

                boundaryadded: function (result) {
                    $(document).trigger('addBoundary', [result]);
                },
                boundarymodified: function (result) {
                    $(document).trigger('addBoundary', [result]);
                },
                boundaryremoved: function (result) {
                    if (!result.isClearAll)
                        $(document).trigger('updateCounts');
                },

                //called when help link is clicked on map.
                helpcontentloaded: function (result) {
                    $('.adc-help-close').text('Close');
                },
                clearall: function (result) {
                    $(document).trigger('clearAllSelections');
                    //$('fieldset').datasetFilter('criteria', 'MapBasedSearch').find('#shapeDetails').empty();
                },
                //this event is triggered whenever a popup is opened.
                popupcontentupdated: function (e) {
                    if (e.data.type == "upload") {
                        $('.adc-popup-title-input').attr('disabled', 'disabled');
                    }
                },
                move: function (e) {

                    //starting position of map loading, need to skip this condition
                    if ((e.bounds.left == -142.51660155630742
                        && e.bounds.right == -53.48339844369871
                        && e.bounds.top == 53.3882612923947
                        && e.bounds.bottom == 20.96916290467462) ||
                    (e.bounds.left == -152.8876953048584
                        && e.bounds.right == -43.11230469514231
                        && e.bounds.top == 53.3882612923947
                        && e.bounds.bottom == 20.96916290467462) ||
                    (e.bounds.left == -120.25830077815007
                        && e.bounds.right == -75.74169922184976
                        && e.bounds.top == 46.67019313895853
                        && e.bounds.bottom == 30.398964378009946) ||
                    (e.bounds.left == 172.96679688739584
                        && e.bounds.right == -8.966796887395253
                        && e.bounds.top == 64.1525580231989
                        && e.bounds.bottom == 0.4916632491186306)) {
                        return;
                    }

                    if (!isCurrentBoundsWithinStartingBounds(e.bounds.left, e.bounds.right, e.bounds.top, e.bounds.bottom)) {
                        ShowPopup();
                        map.setCenter(-98, 39, 4);
                    }
                }
                
            });

            if ($('div.shapeFilesIcon').length > 0)
                $('.adc-toolbar').find('div.adc-toolbar-section:eq(1)').append($('div.shapeFilesIcon').html());
        } else
            map.render(id);

        $.ajax({
            url: '/MapSearch/SetMappingData',
            cache: false,
            data: { sessionId: getQueryString("bas_session") },
            success: function (data2) {
                loadDataToMap(data2);
                $(".adc-toolbar-zoomto-input").width("300");
            }
        });


    });
};